
import { useState, useEffect } from "react";


import { Button, IconButton, Box, TextField, Paper } from "@material-ui/core";
import SendIcon from '@material-ui/icons/Send';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';

import ServiceAPI from "../../../service/ServiceAPI";
import CompletionLockerNote from "../../../model/CompletionLockerNote";
import { getMemberId } from "../../../utils/AuthUtils";

const LockerNotesView = (props) => {
  console.assert(props.workflowViews);
  console.assert(props.setCurrentView);
  console.assert(props.selectedLocker);
  console.assert(props.completionRecord);

  const [lockerNotes, setLockerNotes] = useState(null);
  const [usersNote, setUsersNote] = useState("");

  useEffect(() => {
    _loadLockerNotesListing();
  }, []);

  /**
   * Loads the current locker and completion record Locker Notes from the API
   */
  const _loadLockerNotesListing = () => {
    let lockerId = props.selectedLocker.getId();
    let completionRecordId = props.completionRecord.getId();

    ServiceAPI.CompletionLockerNotes().getCompletionLockerNoteListing(completionRecordId, lockerId).then(
      (data) => {
        setLockerNotes(data);
      }
    );
  }

  /**
   * Cancel out of the notes screen, back to the locker content view
   */
  const handleClick_cancelNote = () => {
    props.setCurrentView(props.workflowViews.LockerContentView);
  }

  /**
   * Delete the selected note for the current user
   * @param {*} note 
   */
  const handleClick_deleteNote = (note) => {
    ServiceAPI.CompletionLockerNotes().deleteExistingCompletionLockerNote(note).then(() => _loadLockerNotesListing() );
  }

  /**
   * Handles sedn the new note to the server
   */
  const handleClick_addNote = () => {
    if (usersNote.trim().length === 0) {
      handleClick_cancelNote();
      return; // If the user clicks done with no note, treat it as a Cancel instead.
    }

    let lockerNote = new CompletionLockerNote();
    lockerNote.setCompletionRecordId(props.completionRecord.getId());
    lockerNote.setContainerId(props.selectedLocker.getId());
    lockerNote.setNotes(usersNote);

    ServiceAPI.CompletionLockerNotes().createNewCompletionLockerNote(lockerNote).then(
      () => {
        props.setCurrentView(props.workflowViews.LockerContentView);
      }
    );
    
  }

  const renderNotes = () => {
    if (lockerNotes === null || lockerNotes?.length === 0) {
      return <h3>There are no locker notes.</h3>;
    }
    
    let notesJsx = [];

    lockerNotes.map((note) => {
      let isNoteFromCurrentUser = note.getMemberId() == getMemberId();

      let deleteBtnJsx = (
        <IconButton aria-label="delete" onClick={() => handleClick_deleteNote(note)}>
          <DeleteIcon />
        </IconButton> 
      );

      let noteJsx = (
        <Paper
          elevation={3} 
          key={note.getId()} 
          className={ isNoteFromCurrentUser ? 'locker-note current-user-note' : 'locker-note other-user-note'}
        >
          <Box display={'flex'}>
            <Box flex={1}>{ note.getNotes() }</Box>
            { isNoteFromCurrentUser ? deleteBtnJsx : null }
          </Box>
        </Paper>
      );

      notesJsx.push(noteJsx);
    });

    return notesJsx;
  }

  return (
    <Box id="complete-inventory-loceker-notes" marginLeft={1} marginRight={1} display={'flex'} flexDirection={'column'} height={'90%'}>
      <Box>
        <h1>{ props.selectedLocker.getName() }</h1>
      </Box>

      <Box overflow={'auto'} flex={1} height={'100%'}>
        { renderNotes() }
      </Box>

      <Box paddingTop={'1em'}>
        <TextField
          id="outlined-helperText"
          label="Your note"
          defaultValue=""
          variant="outlined"
          fullWidth="true"
          maxlength="180"
          value={usersNote}
          onChange={(event) => { setUsersNote(event.target.value) } }
        />
      </Box>
      <Box paddingTop={'1em'} justifyContent={'space-evenly'} display={'flex'}>
        <Button variant="contained" color="default" size="large" startIcon={<CloseIcon />} onClick={handleClick_cancelNote}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" size="large" startIcon={<SendIcon />} onClick={handleClick_addNote}>
          Done
        </Button>
      </Box>
    </Box>
  );
}

export default LockerNotesView;